/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable dot-notation */
/* eslint-disable react/no-array-index-key */

import { useCallback } from 'react';
import { connect } from 'react-redux';

import Button from 'components/form/Button.component';
import CurrencySign from 'components/price/CurrencySign.component';
import { DOWNLOAD_EXCEL } from 'constants/csv.const';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';
import asArray from 'utils/arrays/asArray.util';
import { exportCSV } from 'utils/converters/csv.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import currencySign from 'utils/intl/currencySign.util';
import C from 'utils/values/constant.util';
import fixed from 'utils/values/fixed.util';

import { convertToMoneyAfterVat } from 'reports/utils';

import CN from './ProductSales.module.scss';

const TABLE_HEADERS = C(['Product', 'Staff', 'Number sold', 'Revenue']);

const ProductSalesByStylist = ({ productSalesByStylist, startDate, endDate, currentCurrencySign }) => {
  const productSalesByStylistArr = asArray(productSalesByStylist?.lastRequestResponse);

  const handleExportCsv = useCallback(() => {
    const csvData = productSalesByStylistArr.map((product) => {
      const values = [
        product.product,
        product.stylist,
        product.sold,
        currencySign({ value: fixed(convertToMoneyAfterVat(product.revenue)), currentSalonAbbr: currentCurrencySign }),
      ];

      return TABLE_HEADERS.reduce((acc, header, index) => {
        acc[header] = values[index];
        return acc;
      }, {});
    });

    exportCSV({ data: csvData, fileName: 'Retail Sales by Product' });
  }, [currentCurrencySign, productSalesByStylistArr]);

  const hasTableData = fromAnyToBool(productSalesByStylistArr.length);

  return (
    <div id="retail-sales-by-staff-members">
      <div className="t-bgr cfix">
        <div className="t-wrap">
          <div className={CN.tableHeader}>
            <h2>Retail Sales by Staff Member</h2>
            <Button onClick={handleExportCsv} disabled={!hasTableData} variant="primaryForce" width="small" height="xs">
              <span className={CN.buttonFont}>{DOWNLOAD_EXCEL}</span>
            </Button>
          </div>

          <div className="t-discount cfix not-footer">
            <table className="discount-tbl" id="table-to-xls-5">
              <tbody>
                <tr>
                  <td colSpan="3">
                    <div className="date-in-tbl-for-export">
                      From <strong>{startDate}</strong> to <strong>{endDate}</strong>{' '}
                    </div>
                  </td>
                </tr>
                <tr className="t-h first-row">
                  <th className="a3 h" style={{ width: '168px' }}>
                    {TABLE_HEADERS[0]}
                  </th>
                  <th className="a3 h text-r" style={{ width: '121px' }}>
                    <span className="bubble">
                      <span className="tooltip">
                        <div />
                      </span>
                    </span>
                    <span className="column-title">{TABLE_HEADERS[1]}</span>
                  </th>
                  <th className="a3 text-r" style={{ width: '121px' }}>
                    <span className="bubble">
                      <span className="tooltip">
                        <div />
                      </span>
                    </span>
                    <span className="column-title">{TABLE_HEADERS[2]}</span>
                  </th>
                  <th className="a3 text-r" style={{ width: '121px' }}>
                    <span className="bubble">
                      <span className="tooltip">
                        <div />
                      </span>
                    </span>
                    <span className="column-title">{TABLE_HEADERS[3]}</span>
                  </th>
                  <th style={{ width: 'auto' }} />
                </tr>
                {productSalesByStylistArr.map((item, index) => (
                  <tr className="t-h" key={`${item.product}-2-${index}`}>
                    <td className="stylist-name">{item.product}</td>
                    <td className="t-value text-r">{item.stylist}</td>
                    <td className="t-value">{item.sold}</td>
                    <td className="t-value">
                      <CurrencySign />
                      {fixed(convertToMoneyAfterVat(item.revenue))}
                    </td>
                    <td />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <br />
      <br />
      <br />
    </div>
  );
};

const mapStateToProps = (state) => ({
  currentCurrencySign: selectCurrentSalonCurrency(state),
});

export default connect(mapStateToProps)(ProductSalesByStylist);
